import './CookiePolicy.css';

function CookiePolicy() {
    return (
        <div className='cookie-policy-container'>
            <h1 className='cookie-policy-title'>Cookie Policy</h1>

            <p>
                Questa pagina descrive le tipologie di cookie utilizzate da questo sito web e le modalità
                per gestirle, in conformità al Regolamento (UE) 2016/679 e al Provvedimento generale
                dell'Autorità Garante per la protezione dei dati personali in materia di cookie.
            </p>

            <h2>Cosa sono i cookie</h2>
            <p>
                I cookie sono piccoli file di testo che i siti visitati inviano al browser dell'utente, dove
                vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva.
            </p>

            <h2>Cookie utilizzati da questo sito</h2>
            <p>
                Questo sito non utilizza cookie di profilazione né cookie analitici o pubblicitari di terze
                parti. Vengono eventualmente utilizzati solo cookie tecnici, strettamente necessari al
                funzionamento del sito, per i quali non è richiesto il consenso preventivo dell'utente ai
                sensi della normativa vigente.
            </p>

            <h2>Link a siti e servizi di terze parti</h2>
            <p>
                Il sito contiene collegamenti (link) a piattaforme esterne come Facebook e YouTube. Questi
                collegamenti aprono i rispettivi siti in una nuova scheda: una volta che l'utente li visita,
                tali piattaforme possono installare propri cookie secondo le rispettive policy, sulle quali
                l'Associazione Settemotivi ODV non ha alcun controllo. Si invita a consultare le informative
                privacy e cookie dei singoli servizi esterni.
            </p>

            <h2>Come gestire i cookie dal browser</h2>
            <p>
                È possibile gestire o disabilitare i cookie direttamente dalle impostazioni del proprio
                browser. Di seguito i link alle guide dei browser più diffusi:
            </p>
            <ul>
                <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer">Google Chrome</a></li>
                <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noreferrer">Mozilla Firefox</a></li>
                <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer">Safari</a></li>
                <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noreferrer">Microsoft Edge</a></li>
            </ul>

            <h2>Titolare del trattamento</h2>
            <p>
                Associazione Settemotivi ODV – Via De Paoli n. 19 – 33170 Pordenone (PN) – C.F. 91100000933<br />
                Email: <a href="mailto:segreteria@settemotivi.it">segreteria@settemotivi.it</a>
            </p>
        </div>
    );
}

export default CookiePolicy;
